import React, {useState} from "react";
import axios from "axios";

function useOpengraphData(session) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false);
    const [ data, setData ] = useState({
        title: undefined,
        image_url: undefined
    })

    const fetch = (url) => {
        if (url) {
            setLoading(true)
            setError(false)
            axios.get(
                '/v1/admin/news/opengraph_data',
                {
                    params: {source_url: url},
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-Admin-User-Email': session.email,
                        'X-Admin-User-Token': session.token
                    }
                }
            ).then((response) => {
                const { og, status } = response.data;
                setLoading(false)
                if (status === 'fetched' && og.title) {

                    setData({
                        title: og.title, image_url: og.images[0]
                    })
                } else {
                    setError(true)
                }
            });
        }
    }

    return {
        loading,
        error,
        data,
        fetch
    };
}

export default useOpengraphData;